import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    Box,
    Stack,
    useToast
} from '@chakra-ui/react';
import Form from '@rjsf/chakra-ui';
import validator from "@rjsf/validator-ajv8";
import { reverseTransformData, transformData } from '../../util/helper';
import { createNewGenre, getGenreData, updateGenreData } from '../../services/Genres';
import { handleApiError, showSuccessToast } from '../../util/errorHandler';

const Genres = () => {

    const { alias } = useParams();
    const [processedData, setProcessedData] = useState({});
    const [quickSave, setQuickSave] = useState(false);
    const toast = useToast();
    const navigate = useNavigate();

    const schema = {
        "title": "Genre Fields",
        "description": "",
        "type": "object",
        "properties": {
            alias: {
                type: "string",
                title: "Alias",
                default: ""
            },
            name: {
                "type": "string",
                "title": "Name",
                "default": ""
            },
        },
        required: ['alias']
    };

    const uiSchema = {
        "ui:submitButtonOptions": {
            "submitText": "Save",
            "norender": false,
            "props": {
                "disabled": false,
                "className": "button button--primary button--blue",
                "loadingText": "Saving..",
                "colorScheme": "teal"
            }
        },

        alias: {
            'ui:emptyValue': '',
            'ui:readonly': !!alias,
        },
        name: {
            "ui:emptyValue": ""
        },
    };

    const formData = processedData;

    // Fetch initial data
    useEffect(() => {
        const getBasicData = async () => {
            try {
                if (alias) {
                    const result = await getGenreData(alias);
                    if (result && result?.[0]) {

                        const fieldsToTransform = [];
                        const transformedData = transformData(result?.[0], fieldsToTransform);

                        // To Show image on form need to provide url to image field which is only used to show the image
                        setProcessedData(transformedData);
                    }
                }
            } catch (error) {
                handleApiError(error, toast, {
                    defaultErrorMessage: "Failed to fetch data"
                });
            }
        };

        getBasicData();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [alias, quickSave]);



    // Submit updated data
    const handleSubmit = async (formData) => {

        const updatedFormData = reverseTransformData(formData, []);

        try {
            if (alias) {
                const result = await updateGenreData(alias, updatedFormData);

                if (result?.status === 200) {
                    setQuickSave(prev => !prev);
                    showSuccessToast(toast, "Data updated successfully");
                }
            } else {
                const result = await createNewGenre(updatedFormData);  // Call the create API
                if (result?.status === 201) {
                    setQuickSave(prev => !prev);
                    showSuccessToast(toast, "New Genre created successfully");
                    navigate(`/genres/${result?.data?.genres?.[0]?.alias}`);  // Navigate to the newly created genre
                }
            }
        } catch (error) {
            handleApiError(error, toast);
        }
    };


    return (
        <Stack flexDirection={'row'} gap={"15px"} alignItems={"flex-start"}>
            <Box width={"600px"}>
                <Form
                    schema={schema}
                    uiSchema={uiSchema}
                    formData={formData}
                    validator={validator}
                    onSubmit={(e) => handleSubmit(e.formData)}
                />
            </Box>
        </Stack>
    );
};

export default Genres;